// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { BooleanField } from "@hex-insights/forms";
import { SharingPolicyFormValues } from "../../FormUtilities";
import { AnnouncementSelectField } from "../Announcement";
import { CalendarEventSelectField } from "../CalendarEvent";
import { NewsletterSelectField } from "../Newsletter";
import { PostSelectField } from "../Post";
import { BaseFieldProps } from "../shared";
import { UserSelectField } from "../User";
import { UserGroupSelectField } from "../UserGroup";

/**
 * Generic props for fields of the SharingPolicy model.
 */
type FieldProps<K extends keyof SharingPolicyFormValues.Base = keyof SharingPolicyFormValues.Base> = BaseFieldProps<
	Pick<SharingPolicyFormValues.Base, K>
>;

/**
 * Field component for the `isPublic` field of the SharingPolicy model.
 */
export function IsPublic({ formState, ...props }: FieldProps<"isPublic">) {
	return <BooleanField formState={formState} name="isPublic" {...props} />;
}

export namespace Announcement {
	export type SelectProps = FieldProps<"announcementID"> &
		Omit<AnnouncementSelectField.SelectProps<SharingPolicyFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `announcement` edge of the SharingPolicy model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <AnnouncementSelectField.Select formState={formState} name="announcementID" optional {...props} />;
	}
}

export namespace CalendarEvent {
	export type SelectProps = FieldProps<"calendarEventID"> &
		Omit<CalendarEventSelectField.SelectProps<SharingPolicyFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `calendarEvent` edge of the SharingPolicy model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <CalendarEventSelectField.Select formState={formState} name="calendarEventID" optional {...props} />;
	}
}

export namespace Newsletter {
	export type SelectProps = FieldProps<"newsletterID"> &
		Omit<NewsletterSelectField.SelectProps<SharingPolicyFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `newsletter` edge of the SharingPolicy model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <NewsletterSelectField.Select formState={formState} name="newsletterID" optional {...props} />;
	}
}

export namespace Post {
	export type SelectProps = FieldProps<"postID"> &
		Omit<PostSelectField.SelectProps<SharingPolicyFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `post` edge of the SharingPolicy model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <PostSelectField.Select formState={formState} name="postID" optional {...props} />;
	}
}

export namespace UserGroups {
	export type SelectProps = FieldProps<"userGroupIDs"> &
		Omit<UserGroupSelectField.MultiSelectProps<SharingPolicyFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `userGroups` edge of the SharingPolicy model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <UserGroupSelectField.MultiSelect formState={formState} name="userGroupIDs" {...props} />;
	}
}

export namespace Users {
	export type SelectProps = FieldProps<"userIDs"> &
		Omit<UserSelectField.MultiSelectProps<SharingPolicyFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `users` edge of the SharingPolicy model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <UserSelectField.MultiSelect formState={formState} name="userIDs" {...props} />;
	}
}
